/**
 * @generated SignedSource<<6b3fc21eb2fcce4a6023420364c506d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAddShippingAddress_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingForm_buyer">;
  readonly " $fragmentType": "CheckoutAddShippingAddress_buyer";
};
export type CheckoutAddShippingAddress_buyer$key = {
  readonly " $data"?: CheckoutAddShippingAddress_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddShippingAddress_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutAddShippingAddress_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingForm_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "86d9d484ec3ed6f92015f1471e45d521";

export default node;
